<div *ngIf="action.uri">
    <h3><a href="{{ action.uri }}"><span class="fas fa-{{ action.icon }}"></span> {{ action.title }}</a></h3>
</div>
<div *ngIf="! action.uri">
    <h3><span class="fas fa-{{ action.icon }}"></span> {{ action.title }}</h3>
</div>
<div [innerHtml]="action.description"></div>
